<div
  class="searchContent"
  [ngClass]="{
    open: isSearchOpen,
    'searchContent--modal': parentLocation == 'modal',
    'searchContent--header': parentLocation == 'header'
  }"
>
  <div class="searchInput">
    <form id="search" #f="ngForm" (ngSubmit)="sendQueryToSearch(f.value)" role="search" action=".">
      <input
        type="search"
        #searchInput
        [(ngModel)]="searchValue"
        (ngModelChange)="listenComp($event)"
        name="searchValue"
        i18n-placeholder="@@HEADER.SEARCH.INPUT_PLACEHOLDER"
        placeholder="Search for items, designers..."
        class="searchContentBox ais-SearchBox-input"
        autocomplete="off"
        spellcheck="false"
      />
      <span
        *ngIf="searchValue !== ''"
        class="searchbar__clear searchbar__clear--content d-md-none"
        (click)="clearSearch()"
        i18n="@@HEADER.SEARCH.CLEAR_BTN"
        >Clear</span
      >
    </form>
  </div>
  <!-- On cache la barre déroulante si on n'a pas de suggestions d'algolia -->
  <div class="suggestions" [ngClass]="{open: isSearchOpen}" *ngIf="suggestionsResults?.products">
    <div *ngIf="searchValue !== ''" class="suggestions__autocomplete">
      <ul *ngIf="suggestionsResults?.brands.length > 0" class="suggestions__list">
        <li class="suggestions__list__title" i18n="@@SEARCH.SUGGESTIONS.BRANDS">Brands</li>
        <li *ngFor="let item of suggestionsResults?.brands" class="suggestions__list__item">
          <a
            class="suggestions__itemLink"
            [routerLink]="[item.link, '']"
            (click)="selectSearchSuggestion(item.name, 'suggestion brand')"
          >
            <span class="suggestions__itemTxt suggestions__itemTxt--brand">{{ item?.name }}</span>
          </a>
        </li>
      </ul>
      <ul class="suggestions__list">
        <li class="suggestions__list__title">
          <span i18n="@@SEARCH.SUGGESTIONS.ALL_THE_RESULTS"
            >All the results for &laquo;&nbsp;{{ searchValue }}&nbsp;&raquo;</span
          >
        </li>
        <li *ngFor="let item of suggestionsResults?.products" class="suggestions__list__item">
          <a
            class="suggestions__itemLink"
            [routerLink]="['/search/', '']"
            [queryParams]="{q: item?.query | superTrim}"
            (click)="selectSearchSuggestion(item.query, 'suggestion product')"
            ><span class="suggestions__itemTxt">{{ item?.query }}</span></a
          >
        </li>
      </ul>
    </div>
    <div *ngIf="recentSearches.length && searchValue === ''" class="suggestions__section suggestions__recent">
      <div class="suggestions__title" i18n="@@HEADER.SEARCH.MODAL.RECENT_TITLE">Recent searches</div>
      <ul>
        <li *ngFor="let item of recentSearches" class="suggestions__list__item">
          <a
            class="suggestions__itemLink"
            [routerLink]="['/search/', '']"
            [queryParams]="{q: item?.query | superTrim}"
            (click)="selectSearchSuggestion(item.query, 'recent')"
          >
            <span class="suggestions__itemTxt">{{ item?.query }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div *ngIf="searchValue === ''" class="suggestions__section suggestions__popular">
      <div class="suggestions__title" i18n="@@HEADER.SEARCH.MODAL.POPULAR_TITLE">Popular searches</div>
      <ul class="suggestions__list">
        <li *ngFor="let item of mostPopular" class="suggestions__list__item">
          <a
            class="suggestions__itemLink"
            [routerLink]="['/search/', '']"
            [queryParams]="{q: item?.query | superTrim}"
            (click)="selectSearchSuggestion(item.query, 'popular')"
          >
            <span class="suggestions__itemTxt">{{ item?.query }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
